import { useEffect, useState } from 'react';
import styled from 'styled-components';

const LinearGradient = styled.div`
  ${(props) => `
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8));
    width: ${props.width}px;
    height: ${props.height}px;
    position: absolute;
    z-index: 2;
    bottom: 0
  `}
`;

/**
 * Gradient component to cover locked content(posts, shoutouts, etc.)
 */
const LockGradient = ({ visible, observer }) => {
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);

  /**
   * Checks the referenced div(observer)
   * updates the component dimensions accordingly
   */
  useEffect(() => {
    if (!visible || !observer) return;

    // The observer instance
    const resizeObserver = new ResizeObserver(() => {
      if (!observer.current) return;
      const { offsetHeight, offsetWidth } = observer.current;
      if (offsetWidth !== width) setWidth(offsetWidth);
      if (offsetHeight !== height) setHeight(offsetHeight);
    });

    // Initiate the observer
    resizeObserver.observe(observer.current);

    // Clear the instance upon dismount
    return () => resizeObserver.disconnect();
  }, [observer]);

  if (!visible) return null;

  return <LinearGradient width={width} height={height} />;
};

export default LockGradient;
